import { render, staticRenderFns } from "./ZigBeePaster.vue?vue&type=template&id=23ad9022&scoped=true&"
import script from "./ZigBeePaster.vue?vue&type=script&lang=js&"
export * from "./ZigBeePaster.vue?vue&type=script&lang=js&"
import style0 from "./ZigBeePaster.vue?vue&type=style&index=0&id=23ad9022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad9022",
  null
  
)

export default component.exports